<template>
<div>
<ContentHeader :title="$store.state.languages.lang_phrases.uygunsuzluklar"  ></ContentHeader>

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<div class="content_card_content" v-if="!loading">

<DataTable 
:value="loaded_inputfields" 
:paginator="true" 
:lazy="true" 
:page="page+1"
:first="first"
class="p-datatable-suppliers" 
:rows="10"
dataKey="id" 
:rowHover="true"
:loading="list_loading"
@page="onPage($event)" 
:totalRecords="totalRecords"	
responsiveLayout="scroll"
>

<template #empty>
<h4 class="text-primary text-center">{{$store.state.languages.lang_phrases.bu_asama_icin_tanimli_uygunsuzluk_tipi_bulunmuyor}}</h4>
</template>

<template #header>
<div class="grid">
<div class="col-12 md:col-8  pt-1">

<span class="text-primary mr-2">{{$store.state.languages.lang_phrases.aktif_donem}}:</span>
<Dropdown v-model="selected_period_id" :options="projectperiods" optionLabel="name" optionValue="id" :placeholder="$store.state.languages.lang_phrases.aktif_donem" class="mr-2 p-inputtext-sm" @change="activePeriodChanged" />

<template v-if="questionlists.length">
<span class="text-primary mr-2">{{$store.state.languages.lang_phrases.soru_listesi}}:</span>
<Dropdown v-model="selected_questionlist_id" :options="questionlists" optionLabel="name" optionValue="id" :placeholder="$store.state.languages.lang_phrases.soru_listesi" class="mr-2 p-inputtext-sm" @change="activeQuestionListChanged" />	
</template>



</div>

<div class="col-12 md:col-4  pt-1 flex justify-content-end">
<Button :label="$store.state.languages.lang_phrases.excel_rapor_indir" icon="pi pi-cloud-download" class="p-button-outlined p-button-sm" @click="downloadExcel" :loading="downloading_report"/>
</div>

</div>

</template>




<Column   header="Soru"  sortable field="name" style="min-width: 14rem">
<template #body="slotProps">
<p class="text-primary" @click="test(slotProps.data)">{{slotProps.data.name}}</p>
</template>
</Column>

<Column   v-for="column in columns" :header="column.name"   :field="column.id" style="min-width: 8rem">

<template #body="slotProps">

<template v-if="slotProps.data[column.id]">
	<template v-if="column.id=='inputfieldclasses'">
		<Tag 
    class="ml-2  mb-2 custom-chip" 
    v-for="inputfieldclass in slotProps.data.inputfieldclasses"
    :value="inputfieldclass.name" 
    :style="'background-color:'+inputfieldclass.color"
    />
	</template>
	<template v-else>
		<p><b>{{slotProps.data[column.id]}}</b></p>
	</template>
	
</template>


<template v-else>
	<span class="material-symbols-outlined text-red-500 md-20">do_not_disturb_on</span>
</template>
</template>
</Column>


</DataTable>

</div>


</div>
</template>

<script>
import * as XLSX from 'xlsx/xlsx.mjs';
export default {

  name: 'ProjectNonconformities',

  data () {
    return {
			loading:true,
			inputfields:[],
			loaded_inputfields:[],
			totalRecords:0,
			questionlist:null,
			questionlists:[],
			selected_questionlist_id:null,
			nonconformity_types:[],
			inputfieldclasses:[],
			selected_period_id:null,
			projectperiods:[],
			columns:[],
			sections:[],
			downloading_report:false,
			list_loading:false,
			sectiondepth:1,
			first:0,
			page:0,
    }
  },
  async mounted()
  {
  	this.projectperiods = await this.generalApiGetWithoutLoader("projectperiods/"+this.$store.state.projects.project.id)
  	let active =  await this.projectperiods.find((item)=>{return item.activeperiod == 1})
    if(active)
    {
      this.selected_period_id = active.id
    }
    this.questionlists = await this.generalApiGetWithoutLoader("project_questionlists/"+this.$store.state.projects.project.id)
    console.log("questionlists")
    console.log(this.$store.state.projects.project.id)
    console.log(this.questionlists)
    if(this.questionlists.length)
    {
    	this.questionlist = this.questionlists[0]
    	await this.setQuestionListData()
    }    
  	
  	await this.getData()
  	this.loading = false
  },
  methods:{
  	async setQuestionListData()
  	{

  		//inputfieldclasses
	    this.inputfieldclasses = await this.generalApiGetWithoutLoader("inputfieldclasses/"+this.questionlist.id)
	    if(this.inputfieldclasses.length)
	    {
	    	this.columns.push({name:"Soru Sınıfı",id:"inputfieldclasses"})
	    }
	    //inputfieldclasses

	    //sections
	    let parent_sections = await this.getQuestionSections()
	  	await this.calculateCatDepth(parent_sections)
	  	let depth_ind = 1
	  	while(depth_ind<=this.sectiondepth)
	  	{
	  		if(depth_ind===1)
	  		{
	  			this.columns.push({name:"Üst Bölüm",id:"child_section_"+depth_ind})
	  		}
	  		else
	  		{
	  			this.columns.push({name:"Alt Bölüm",id:"child_section_"+depth_ind})
	  		}
	  		depth_ind++  		
	  	}
	  	//sections


	  	this.inputfields = []
	  	for(let parent_section of parent_sections)
	    {
	    	let parent_inputfields = this.getSectionInputfields(parent_section)
	    	this.inputfields = this.inputfields.concat(parent_inputfields)
	    }
	    this.totalRecords = this.inputfields.length



	    //nonconformity_types
	  	let nonconformity_types = await this.generalApiGetWithoutLoader("questionlistnonconformitytypes/"+this.questionlist.id)
	  	
	  	if(!nonconformity_types.length)
	  	{
	  		this.loading = false
	  		return false
	  	}
	  	for(let nonconformity_type of nonconformity_types) 
	  	{
	  		this.columns.push({name:nonconformity_type.name+" Açık",id:nonconformity_type.id+"_open"})
	  		this.columns.push({name:nonconformity_type.name+" Kapalı",id:nonconformity_type.id+"_closed"})
	  		this.columns.push({name:nonconformity_type.name+" Toplam",id:nonconformity_type.id+"_total"})
	  	}
	  	this.nonconformity_types =  nonconformity_types
	  	this.columns.push({name:"Tüm Açık Uygunsuzluklar Toplam",id:"open"})
	  	this.columns.push({name:"Tüm Kapalı Uygunsuzluklar Toplam",id:"closed"})
	  	this.columns.push({name:"Tüm Uygunsuzluklar Toplam",id:"total"})
	  	//nonconformity_types

  	},
  	async calculateCatDepth(parent_sections)
  	{
  		
  		for(let parent_section of parent_sections)
  		{
  			let calc_depth = await this.getDeeper(parent_section.id,1)
  			if(calc_depth>this.sectiondepth)
  			{
  				this.sectiondepth = calc_depth
  			}
  		}
  		

  	},
  	async getDeeper(section_id,current_depth)
  	{ 
  		let sub_sections = await this.hasSubSections(section_id)
  		if(sub_sections=="end")
  		{
  			
  		}
  		else
  		{
  			current_depth ++
  			let depth = 1
  			for(let sub_section of sub_sections)
  			{
  				let calc_depth = await this.getDeeper(sub_section.id,current_depth)
  			}
  			
  		}
  		
  		return current_depth
  	},
  	async hasSubSections(section_id)
  	{
  		let sub_sections = this.all_sections.filter(item=>item.parent_id == section_id)
  		if(sub_sections.length)
  		{
  			return sub_sections
  		}
  		else
  		{
  			return "end"
  		}
  	},
  	test(item)
  	{
  		console.log(item)
  	},
  	async downloadExcel()
  	{
  		this.downloading_report =  true
		let sheet = []
		let row =  [
		"Soru",
		]
		for(let column of this.columns)
		{
			row.push(column.name)
		}
		sheet.push(row)
		let new_row
		for(let item of this.inputfields)
		{
			item = await this.resolveInputfield(item)
			new_row = this.generateReportExcelRow(item)
			sheet.push(new_row)
		}
		let ws =  XLSX.utils.json_to_sheet(sheet)
		let wb =  XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb,ws,"Sorular")
		XLSX.writeFile(wb,this.$store.state.projects.project.name+" uygunsuzluk raporu.xls")
		this.downloading_report =  false
  	},
  	generateReportExcelRow(item)
  	{
  		let row = []
  		row.push(item.name)
  		for(let column of this.columns)
  		{
  			let item_data = item[column.id]
  			if(item_data)
  			{
  				if(column.id=="inputfieldclasses")
  				{
  					let the_text = ""
  					for (let i = 0; i < item_data.length; i++)
  					{
  						if(i==item_data.length-1)
  						{
  							the_text =the_text+" "+item_data[i].name
  						}
  						else
  						{
  							the_text =the_text+" "+item_data[i].name+","
  						}
  					}
  					row.push(the_text)
  				}
  				else
  				{
  					row.push(item_data)
  				}
  				
  			}
  			else
  			{
  				row.push("-")
  			}
  		}
  		return row
  	},
  	async activePeriodChanged()
  	{
  		this.page = await 0
  		await this.getData()
  	},
  	async activeQuestionListChanged()
  	{
  		this.questionlist = await this.questionlists.find(item=>item.id == this.selected_questionlist_id)
  		this.page = await 0
  		await this.getData()
  	},
  	async getQuestionSections()
  	{
  		let all_sections = await this.generalApiGetWithoutLoader("questionlists/all_sections/"+this.questionlist.id)
  		
  		let parent_sections = all_sections.filter(item=>item.parent_id === 0)
  		for(let parent_section of parent_sections)
  		{
  			let parent_section_children = this.getChildSections(all_sections,parent_section)
  			if(parent_section_children.length)
  			{
  				parent_section.children = parent_section_children
  			}
  		}

  		
  		this.all_sections = all_sections
  		return parent_sections
  	},
  	getChildSections(all,parent)
  	{
  		let children = all.filter(item=>item.parent_id == parent.id)
  		for(let child of children)
  		{
  			let child_children = this.getChildSections(all,child)
  			if(child_children.length)
  			{
  				child.children = child_children
  			}
  			else
  			{

  			}
  		}
  		return children
  	},  	 
    getSectionInputfields(parent)
    {
    	let inputfields = []
    	if(parent.children && parent.children.length)
    	{
    		for(let child of parent.children)
    		{
    			inputfields = inputfields.concat(this.getSectionInputfields(child))
    		}
    	}
    	else
    	{
    		inputfields = parent.inputfields
    	}
    	return inputfields
    },
    async onPage(event)
    {
        console.log(event)
        this.page = await event.page
        await this.getData()
    },
    async getInputfieldSections(inputfield)
    {
    	let section_ids = []
    	let section = this.all_sections.find(item=>item.id == inputfield.inputfieldsection_id)
    	section_ids.push(section.id)
    	section_ids = await this.getInputfieldParentSection(section_ids,section)
    	let ind = 0
    	while(ind<section_ids.length)
    	{    		
    		let section_by_id = this.all_sections.find(item=>item.id == section_ids[ind])
    		if(section_by_id)
    		{
    			inputfield['child_section_'+(ind+1)] = section_by_id.name
    		}
    		
    		ind ++
    	}

    	return inputfield
    },     
    async getInputfieldParentSection(section_ids,section)
    {
    	let parent_section = this.all_sections.find(item=>item.id == section.parent_id)
    	if(parent_section)
    	{
    		section_ids.unshift(parent_section.id)
    		section_ids = await this.getInputfieldParentSection(section_ids,parent_section)
    	}
    	return section_ids

    },
    async resolveInputfield(inputfield)
    {
    	inputfield = await this.getInputfieldSections(inputfield)
        	let nonconformities = await this.generalApiGetWithoutLoader("questionlists/get_nonconformity_by_inputfield_for_project/"+inputfield.id+"/"+this.selected_period_id+"/"+this.$route.params.id)
        	for(let nonconformity of nonconformities)
        	{
        		let type = this.nonconformity_types.find(item=>item.id == nonconformity.nonconformitytype_id)   
        		 		
        		if(type)
        		{
        			if(nonconformity.status=="open")
        			{
        				let col_index = this.columns.findIndex(item =>item.id == nonconformity.nonconformitytype_id+"_open" )
        				if(inputfield[type.id+"_open"])
        				{
        					inputfield[type.id+"_open"] +=1
        				}
        				else
        				{
        					inputfield[type.id+"_open"] =1
        				}
        				
        			}
        			if(nonconformity.status=="closed")
        			{
        				let col_index = this.columns.findIndex(item =>item.id == nonconformity.nonconformitytype_id+"_closed" )
        				if(inputfield[type.id+"_closed"])
        				{
        					inputfield[type.id+"_closed"] +=1
        				}
        				else
        				{
        					inputfield[type.id+"_closed"] =1
        				}
        				
        			}

        			let type_nonconformities = nonconformities.filter(item=>item.nonconformitytype_id==type.id)
      				inputfield[type.id+"_total"] =type_nonconformities.length        			
        		}
        	}
        	 
        	let opens = nonconformities.filter(item=>item.status=="open")
        	let closeds = nonconformities.filter(item=>item.status=="closed")
        	inputfield["open"] =opens.length 
        	inputfield["closed"] =closeds.length 
        	inputfield["total"] =nonconformities.length 

        	return inputfield
    },

  	async getData()
    {
    	
    	let offset = this.page*10
    	let loaded_inputfields = this.sanitizeArray(this.inputfields)
    	this.loaded_inputfields = loaded_inputfields.slice(offset,offset+10)
    	
			this.list_loading = await true
			for(let inputfield of this.loaded_inputfields)
			{
				inputfield = await this.resolveInputfield(inputfield)
			}
      
			this.list_loading = await false
    }, 
  },
}
</script>

<style lang="css" scoped>
	.p-datatable-thead{
		position: sticky !important;
	}
</style>